// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "form.title[data-v-6f96a4b8]{line-height:1.8}.inline-field[data-v-6f96a4b8]{display:inline-block;font-weight:500;border-bottom:2px dotted var(--v-primary-base);line-height:1.5;cursor:pointer}[data-v-6f96a4b8] .v-item-group{cursor:pointer}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
